import React from "react";
import { PersonStanding } from "lucide-react";
import { useTranslation } from "react-i18next";
import { StoreAdminDetails } from "../../../../types/modules/admin/StoreAdmin.type";
import { formatPhoneNumber } from "../../../../utils/formatNumber";

type Props = {
  store: StoreAdminDetails;
};

const StoreOwner: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  const { owner } = store;

  return (
    <div className="border-t border-LightGrey3 pt-4">
      <h2 className="text-lg font-semibold text-Black mb-2 flex items-center gap-2">
        <PersonStanding className="w-5 h-5 text-primary" /> {t("owner")}
      </h2>
      <div className="grid grid-cols-2 gap-4 text-sm text-muted">
        <p>
          <span className="font-medium text-Black">{t("email")}: </span>
          {owner.email}
        </p>
        <p>
          <span className="font-medium text-Black">{t("name")}: </span>
          {owner.name}
        </p>
          <p>
          <span className="font-medium text-Black">{t("phone")}: </span>
          {formatPhoneNumber(owner.phone)}
        </p>
        <p>
          <span className="font-medium text-Black">{t("city")}: </span>
          {owner.city}
        </p>
      </div>
    </div>
  );
};

export default StoreOwner;
